var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"base-img",attrs:{"src":_vm.resolvedSrc},on:{"click":function($event){return _vm.$emit('click')},"animationend":function($event){return _vm.$emit('animationend')}}})}
var staticRenderFns = []

export { render, staticRenderFns }